module.exports = __webpack_public_path__ + "img/what-is-buynow_2.9f197105.png";